import { apiClient } from './client';
import type { ApiSuccess, PaginationMeta } from '../types';

export interface AmAgreement {
  id: number;
  agreementNumber: string;
  stationId: number;
  stationName: string | null;
  city: string | null;
  ownerName: string | null;
  clientId: number | null;
  clientName: string | null;
  startDate: string;
  endDate: string;
  monthlyRent: number | null;
  escalationPercent: number;
  noticePeriodDays: number;
  status: 'active' | 'expiring' | 'expired' | 'renewed';
  documentUrl: string | null;
  renewalOf: number | null;
  daysRemaining: number | null;
  createdAt: string;
}

export interface CreateAgreementInput {
  stationId: number;
  clientId?: number | null;
  startDate: string;
  endDate: string;
  monthlyRent?: number;
  escalationPercent?: number;
  noticePeriodDays?: number;
  documentUrl?: string;
}

export interface RenewAgreementInput {
  startDate?: string;
  endDate?: string;
  monthlyRent?: number;
  escalationPercent?: number;
  noticePeriodDays?: number;
  documentUrl?: string;
}

export const amAgreementsApi = {
  async list(params: Record<string, unknown> = {}): Promise<{ data: AmAgreement[]; meta: PaginationMeta }> {
    const { data } = await apiClient.get<ApiSuccess<AmAgreement[]>>('/am-agreements', { params });
    return { data: data.data, meta: data.meta as PaginationMeta };
  },
  create: async (body: CreateAgreementInput) => (await apiClient.post<ApiSuccess<AmAgreement>>('/am-agreements', body)).data.data,
  update: async (id: number, body: Partial<CreateAgreementInput>) => (await apiClient.put<ApiSuccess<AmAgreement>>(`/am-agreements/${id}`, body)).data.data,
  renew: async (id: number, body: RenewAgreementInput) => (await apiClient.post<ApiSuccess<AmAgreement>>(`/am-agreements/${id}/renew`, body)).data.data,
  remove: async (id: number) => { await apiClient.delete(`/am-agreements/${id}`); },
};
